import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import FJBrushCardThree from './FJBrushCardThree';
import FJActionBrushEditCommon from '../../../redux/action/FJActionBrushEditCommon';
import FJUtil from '../../../util/FJUtil';
import FJConstant from '../../../constants/FJConstant';
import useLocalStore from '../../../hooks/useLocalStore';

const FJBrushCardThreeContainer = memo(function FJBrushCardThreeContainer(props) {
    useLocalStore();
    const dispatch = useDispatch();
    const { className } = props;

    const taskStatus = useSelector(state => state.common.taskStatus);
    const brushEditStatus = useSelector(state => state.brushEditCommon.brushEditStatus);
    const curBrushType = useSelector(state => state.brushEditCommon.curBrushType);
    const isMouseMove = useSelector(state => state.brushEditCommon.isMouseMove);
    const brashSize = useSelector(state => state.brushEditCommon.brushSize);
    const isSlideCompare = useSelector(state => state.brushEditCommon.isSlideCompare);
    const editImageLoadStatus = useSelector(state => state.brushEditCommon.editImageLoadStatus);

    const isDisabled =
        FJUtil.isGeneratingStatus(taskStatus) ||
        brushEditStatus !== FJConstant.DEFAULT ||
        editImageLoadStatus !== FJConstant.SUCCESS;

    const setBrushSize = useCallback(
        (value, type = 'input') => {
            if (isDisabled) return;

            dispatch(FJActionBrushEditCommon.updateBrushSizeAction(Math.round(value), type));
        },
        [dispatch, isDisabled],
    );

    const changeBrushType = useCallback(
        value => {
            if (isDisabled) return;
            dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(value));
        },
        [dispatch, isDisabled],
    );

    const applyOnClick = useCallback(() => {
        dispatch(FJActionBrushEditCommon.applyPhotoRemoveBgBrushAction());
    }, [dispatch]);

    const cancelOnClick = useCallback(() => {
        dispatch(FJActionBrushEditCommon.cancelPhotoRemoveBgBrushAction());
    }, [dispatch]);

    return (
        <FJBrushCardThree
            className={className}
            disabled={isDisabled}
            brashSize={brashSize}
            curBrushType={curBrushType}
            isMouseMove={isMouseMove}
            isSlideCompare={isSlideCompare}
            changeBrushType={changeBrushType}
            changeBrashSize={setBrushSize}
            applyOnClick={applyOnClick}
            cancelOnClick={cancelOnClick}
        />
    );
});

FJBrushCardThreeContainer.propTypes = {
    className: PropTypes.string,
};

export default FJBrushCardThreeContainer;
